// extracted by mini-css-extract-plugin
export default {"rate":"rate_rate__7f2zm","star":"rate_star__Ldjkw","starActive":"rate_starActive__c1do+"};